import * as d3 from "d3";
import {schemeOranges} from "d3-scale-chromatic";

import {formatState, formatMoney} from '../../common';

//Width and height of map
var width = 500;
var height = 250;

var lowColor = '#FEEAD5'
var highColor = '#E55E0B'

// D3 Projection
var projection = d3.geoAlbersUsa()
  .translate([width / 2, height / 2]) // translate to center of screen
  .scale([500]); // scale things down so see entire US

// Define path generator
var path = d3.geoPath() // path generator that will convert GeoJSON to SVG paths
  .projection(projection); // tell path generator to use albersUsa projection

//Create SVG element and append map to the SVG
var svg = d3.select("#welcome-heatmap")
  .append("svg")
  .attr("viewBox", `0 0 ${width} ${height}`);

  // Append Div for tooltip to SVG
var div = d3.select("body")
		    .append("div")
    		.attr("class", "tooltip")
    		.style("opacity", 0);

// Load in my states data!
d3.json('/api/welcome/heatmap', function(stateData) {
  //console.log('stateData', stateData)
  const data = stateData.map(sd => ({
    state: formatState(sd.candidate_office_state),
    value: sd.total
  }));
  //console.log('data', data)
	var dataArray = [];
	for (var d = 0; d < data.length; d++) {
		dataArray.push(parseFloat(data[d].value))
	}
	var minVal = d3.min(dataArray)
	var maxVal = d3.max(dataArray)
	var ramp = d3.scaleLinear().domain([minVal,maxVal]).range([lowColor,highColor])

  // Load GeoJSON data and merge with states data
  d3.json("us-states.json", function(json) {

    //console.log('json', json)

    // Loop through each state data value in the .csv file
    for (var i = 0; i < data.length; i++) {

      // Grab State Name
      var dataState = data[i].state;

      // Grab data value
      var dataValue = data[i].value;

      // Find the corresponding state inside the GeoJSON
      for (var j = 0; j < json.features.length; j++) {
        var jsonState = json.features[j].properties.name;

        if (dataState == jsonState) {

          // Copy the data value into the JSON
          json.features[j].properties.value = dataValue;

          // Stop looking through the JSON
          break;
        }
      }
    }

    // Bind the data to the SVG and create one path per GeoJSON feature
    svg.selectAll("path")
      .data(json.features)
      .enter()
      .append("path")
      .attr("d", path)
      .style("stroke", "#fff")
      .style("stroke-width", "1")
      .style("fill", function(d) { return d.properties.value ? ramp(d.properties.value) : '#ededed' })
      // Modification of custom tooltip code provided by Malcolm Maclean, "D3 Tips and Tricks"
	// http://www.d3noob.org/2013/01/adding-tooltips-to-d3js-graph.html
	.on("mouseover", function(d) {
    //console.log('d', d)
    	div.transition()
      	   .duration(200)
           .style("opacity", .9);
           div.text(`${d.properties.name} - ${d.properties.value ? formatMoney(d.properties.value) : 'None'}`)
           .style("left", (d3.event.pageX) + "px")
           .style("top", (d3.event.pageY - 28) + "px");
	})

    // fade out tooltip on mouse out
    .on("mouseout", function(d) {
      //console.log('d', d)
        div.transition()
           .duration(500)
           .style("opacity", 0);
    });

  });
});
